export const RESOURCE_FORM_MAIN = 'ResourceFormMain';
export const RESOURCE_EXTERNAL_FORM = 'ResourceExternalForm';
export const RESOURCE_EVENTS_FORM = 'ResourceEventsForm';
export const RESOURCE_TASK_FORM = 'ResourceTaskForm';
export const RESOURCE_PLACES_FORM = 'ResourcePlacesForm';
export const RESOURCE_FILES_FORM = 'ResourceFilesForm';
export const RESOURCE_SHARED_FILES_FORM = 'ResourceSharedFilesForm';
export const RESOURCE_AVAILABILITIES_FORM = 'ResourceAvailabilitiesForm';
